<div class="e-search-bar" role="search">
    <mat-form-field
        appearance="fill"
        (click)="hideSuggestionsContainer()"
        (keyup.enter)="hideSuggestionsContainer()"
        (keyup.space)="hideSuggestionsContainer()">
        <mat-select
            placeholder="Select search type"
            panelClass="e-mat-select-panel e-search-bar-select-panel {{ matSelectPanelClass }}"
            disableOptionCentering="true"
            (selectionChange)="getSearchSuggestions()"
            [(ngModel)]="selectedOption">
            <mat-option *ngFor="let option of options" [value]="option">{{ option.label }}</mat-option>
        </mat-select>
    </mat-form-field>

    <div class="e-search-field-container">
        <input
            class="e-search-field"
            type="text"
            placeholder="{{ placeholderText }}"
            [(ngModel)]="searchTerm"
            autocomplete="off"
            (ngModelChange)="getSearchSuggestions()"
            (focus)="showSuggestionsContainer()"
            (keydown)="inputKeyEvents($event)"
            aria-label="Enter a keyword to load a list of suggested results"
            aria-owns="suggestions"
            aria-autocomplete="both"
            [attr.aria-expanded]="showingSuggestionsContainer && showingSuggestions" />
        <i class="far fa-search"></i>

        <button class="e-clear-button" (click)="resetSearch()" aria-label="Clear keywords"><i class="far fa-times"></i></button>

        <div class="e-loading-indicator" *ngIf="loading">
            <mat-spinner [diameter]="20"></mat-spinner>
        </div>

        <div class="e-search-suggestions" id="suggestions" *ngIf="showingSuggestionsContainer" (keydown)="suggestionsKeyEvents($event)">
            <span class="e-placeholder-text" *ngIf="!showingSuggestions && !loading">{{ placeholderText }}</span>
            <span class="e-placeholder-text" *ngIf="loading">Loading...</span>
            <div class="e-suggestions-container" *ngIf="showingSuggestions" role="list">
                <div aria-live="polite" role="status" class="e-visibility-hidden">{{ suggestionsCount }} suggestions found.</div>
                <via-search-suggestion
                    *ngFor="let suggestion of suggestions"
                    [suggestion]="suggestion"
                    (clickSuggestion)="suggestionSearch($event)"></via-search-suggestion>
            </div>
        </div>
    </div>

    <button
        mat-button
        color="primary"
        (click)="submitSearch()"
        #submitButton
        (keyup.tab)="hideSuggestionsContainer()"
        [disabled]="isSubmitButtonDisabled()">
        Go
    </button>
</div>
